export function initTeamDirectors() {
  const expandButtons = document.querySelectorAll('.js-director-expand');

  expandButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      const index = button.dataset.index;
      const description = document.getElementById('description-' + index);
      const isExpanded = description.classList.contains('expanded');

      if (isExpanded) {
        // Collapse
        description.classList.remove('expanded');
        button.setAttribute('aria-expanded', 'false');
        button.querySelector('.expand-text').textContent = button.dataset.expandText;
      } else {
        // Expand
        description.classList.add('expanded');
        button.setAttribute('aria-expanded', 'true');
        button.querySelector('.expand-text').textContent = button.dataset.collapseText;
      }
    });
  });
}
